import React from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";
import { Seo } from "./Seo";
import { SEO } from "../seo/seoConfig";

// Renders per-route SEO (title/description/canonical/OG) for static routes.
// Site-wide business + website JSON-LD lives statically in public/index.html
// (so it is present for crawlers on every route). Dynamic detail pages
// (accommodation, region) render their own <Seo> which overrides these tags.
export default function RouteSeo() {
  const loc = useLocation();
  const { lang } = useI18n();
  const entry = SEO[loc.pathname];
  if (!entry) return null;
  const meta = entry[lang] || entry.fr;
  return <Seo title={meta.title} description={meta.description} path={loc.pathname} lang={lang} />;
}
